import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutStepWizardStyled } from '../CheckoutStepWizardStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const CheckoutStepWizardAP = styled(CheckoutStepWizardStyled)`
    .headerWrapper {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .progressWrapper .progressBlock.progressBlockActive .progressTimer {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        margin-left: ${rem(-10)};
        border-color: unset;
        @media screen and (min-width: ${breakpoints.md}px) {
            margin-left: ${rem(0)};
        }
    }

    .progressWrapper .progressBlock.progressBlockActive .progressTitle {
        top: ${rem(-51)};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    }

    .progressWrapper {
        .progressBlock {
            .progressStep {
                left: ${rem(10)};
            }

            &:last-child {
                @media screen and (max-width: ${breakpoints.sm}px) {
                    left: -75%;

                    &.progressBlockActive {
                        .progressTimer,
                        .progressTitle,
                        .progressStep {
                            display: block !important;
                        }

                        .progressTimer {
                            border: none;
                        }

                        .progressStep {
                            left: ${rem(50)};
                        }
                    }
                }
                @media (max-width: ${breakpoints.md}px) {
                    &.progressBlockActive {
                        .progressStep {
                            left: ${rem(70)};
                        }
                    }
                }
            }
        }

        @media screen and (max-width: ${breakpoints.sm}px) {
            margin-top: ${rem('70px')};
            .progressBlock .progressCar {
                display: block;
            }
        }
        .progressBlock .progressTimer::after {
            display: none;
            ${media.sm`
                display: none;
            `}
        }
        .progressBlock:first-child.progressBlockActive {
            .progressTitle,
            .progressTimer {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                @media (max-width: ${breakpoints.sm}px) {
                    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                }
            }

            .progressTimer {
                @media (max-width: ${breakpoints.sm}px) {
                    left: ${rem(10)};
                    top: ${rem(-50)};
                }
            }
        }
        .progressBlockCompleted .progressTimer {
            @media (min-width: ${breakpoints.sm}px) {
                background: ${({ theme }) => theme.colors.primary};
            }
            color: ${({ theme }) => theme.colors.white};
        }
        .progressBlock .progressTitle {
            text-transform: uppercase;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }
        .progressBlock .progressTimer {
            border-radius: unset;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            border-color: ${({ theme }) => theme.colors.grey13};
        }
    }
`;
